import React from 'react';
import TdLink from './TdLink';

import AppService from '../service/AppService';
import AppConfig from '../domain/AppConfig';
const appConfig:AppConfig = AppService.appConfig();

export default class AppLinkContainer extends React.Component {

  render() {
    return (
      <div className="app-link-container">
        <TdLink action="goto-aperza" href={`https://www${appConfig.baseDomain}`} anchorText="Aperza" openOnNewTab={true}>
          Aperza <i className="fa fa-external-link" aria-hidden="true"></i>
        </TdLink>
        {appConfig.isAperzaCatalogTop &&
          <React.Fragment>
            <div>|</div>
            <TdLink action="goto-aperza-cloud" href={`https://cloud${appConfig.baseComDomain}/home/index.html`} anchorText="Aperza Cloud" openOnNewTab={true}>
            Aperza Cloud <i className="fa fa-external-link" aria-hidden="true"></i>
            </TdLink>
          </React.Fragment>
        }

      </div>
    )
  }

}